var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.589,
    height: 37.252,
    viewBox: "0 0 26.589 37.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark_icon",
    "data-name": "bookmark icon",
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_47",
    "data-name": "Mask Group 47",
    transform: "translate(-2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1.112,1.112V35.164l12.183-8.2,12.182,8.2V1.112Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.223
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M13.437,5.995,15.9,9.61a.172.172,0,0,0,.094.069l4.2,1.222a.173.173,0,0,1,.088.271L17.6,14.629a.173.173,0,0,0-.036.11L17.7,19.11a.172.172,0,0,1-.23.168L13.353,17.8a.18.18,0,0,0-.117,0l-4.115,1.48a.172.172,0,0,1-.23-.168l.135-4.371a.173.173,0,0,0-.036-.11L6.312,11.172A.172.172,0,0,1,6.4,10.9l4.2-1.222a.168.168,0,0,0,.094-.069l2.46-3.615a.173.173,0,0,1,.285,0",
    transform: "translate(-50 10)",
    fill: "#ffed7f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark-icon.569553bdfca8388c44388cf3b1f85585.svg";
export { ForwardRef as ReactComponent };